module.exports = __webpack_public_path__ + "img/noImage.beb1ed93.jpg";